import axiosClient from "../helpers/axiosClient";

export function tournamentEntry(data) {
    let bearerTokenHeader = localStorage.getItem('token');

    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${bearerTokenHeader}`;
    return axiosClient.post('/v1/tournament/entry/checkin', data);
}